module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAdklEQVR42u3QQQ0AIAwEQfwgAAcIxBLCSvDQ302TTfq9GVU1koseDwAAAAAAAAAAAADAf86uzrrvztUaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAkASQGgAAAAAAAAAAAAAAoT2yTbKVKDZOOgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Italy.png
// module id = zYN4
// module chunks = 0 62 63